module.exports = __webpack_public_path__ + "img/SMT_11_Ms_Winifred_Lau.d3df0cd1.jpg";